import { render } from "./Catalog.vue?vue&type=template&id=4b91121b&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=4b91121b&scoped=true&lang=css"
import "./Catalog.vue?vue&type=style&index=1&id=4b91121b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b91121b"]])

export default __exports__